import type { OrderStatus } from "./types";

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending_payment: "결제전",
  accepted: "접수",
  resubmission: "재접수",
  production: "제작",
  production_complete: "제작 완료",
  shipping: "출고/배송",
  delivered: "배송 완료",
  cancelled: "취소",
  refunded: "환불",
};

/**
 * 주문 옵션 스냅샷의 종류 라벨
 *
 * 백엔드 OptionType enum 이름을 그대로 키로 쓴다.
 */
export const ORDER_OPTION_TYPE_LABELS: Record<string, string> = {
  PAPER: "용지",
  BINDING: "제본",
  BOOK_COVER_PAPER: "표지 용지",
  BOOK_INNER_PAPER: "내지 용지",
  BOOK_INSERT_PAPER: "간지",
  BOOK_END_PAPER: "면지",
  PAPER_ORIENTATION: "용지 방향",
};

export const getStatusBadgeColor = (status: OrderStatus): string => {
  switch (status) {
    case "pending_payment":
      return "bg-[#757575] text-white";
    case "accepted":
      return "bg-[#4285f4] text-white";
    case "resubmission":
      return "bg-[#5c9cff] text-white";
    case "production":
      return "bg-[#4285f4] text-white";
    case "production_complete":
      return "bg-[#2196f3] text-white";
    case "shipping":
      return "bg-[#29b43f] text-white";
    case "delivered":
      return "bg-[#1B5E20] text-white";
    case "cancelled":
      return "bg-[#757575] text-white";
    case "refunded":
      return "bg-[#E53935] text-white";
    default:
      return "bg-[#757575] text-white";
  }
};
